<mat-card>
  <mat-card-title>
    <h1>
      <span class="title">{{'admin.countries.upload' | translate}} </span>
      <span>{{'admin.countries.upload-title' | translate}}</span>
    </h1>
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]="fileForm" (ngSubmit)="uploadFile()">
      <div class="form-container">
        <p>{{uploadExplanation}}</p>
        <ul>
          <li><strong>Code: </strong>2 or 3 digit country code. This must be a text value</li>
          <li><strong>Year: </strong>Number representing the year. This must be a numeric value without decimals.</li>
          <li><strong>Population: </strong>Number representing the population for each country/year. This must be a numeric value without decimals.</li>
        </ul>
        <p>Next, there is an example of how the file would look like. The column headers are optional.</p>
        <table mat-table [dataSource]="exampleFileDataSource">

          <ng-container matColumnDef="code" sticky>
            <th mat-header-cell *matHeaderCellDef>{{'admin.countries.code' |translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.code}}</td>
          </ng-container>

          <ng-container matColumnDef="year" >
            <th mat-header-cell *matHeaderCellDef>{{'kf-reporting.year' |translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.year}}</td>
          </ng-container>

          <ng-container matColumnDef="population" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>{{'admin.countries.population' |translate}}</th>
            <td mat-cell *matCellDef="let row">{{row.population}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsExampleFile"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsExampleFile;"></tr>

        </table>
        <p><strong>Warning: </strong>{{uploadWarningExplanation}}</p>
        <mat-form-field appearance="fill">
          <ngx-mat-file-input (change)="getExtension()" [formControl]="fileControl" [accept]="accept" [multiple]="false" [placeholder]="'File to upload'">
            <mat-icon ngxMatFileInputIcon>folder</mat-icon>
          </ngx-mat-file-input>
        </mat-form-field>
        <h3>Valid file types are: .xls, .xlsx.</h3>
        <div class="upload-button-container">
          <button [disabled]="fileForm.invalid || (fileExtension !== 'xls' && fileExtension !== 'xlsx')" mat-raised-button color="primary" type="submit">
            <span>Upload</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
